/**
 * @generated SignedSource<<5209d8f87b13f5ebcfac6f05d486eebe>>
 * @relayHash 4b2d275fae9632939cfb5fdc9d2aa287
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab8af952405ea1766aaafcb4d8fdb0ca3e56e7a57a13c23a0c6dde1eda31a8c9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCalendarMode = "DAY" | "MONTH" | "WEEK" | "%future added value";
export type JiraCalendarWeekStart = "MONDAY" | "SATURDAY" | "SUNDAY" | "%future added value";
export type JiraCalendarViewConfigurationInput = {
  date?: AGG$DateTime | null | undefined;
  endDateField?: string | null | undefined;
  mode?: JiraCalendarMode | null | undefined;
  startDateField?: string | null | undefined;
  viewId?: string | null | undefined;
  weekStart?: JiraCalendarWeekStart | null | undefined;
};
export type dateFieldsPageQuery$variables = {
  configuration?: JiraCalendarViewConfigurationInput | null | undefined;
  includeUserPermissions: boolean;
  projectARIs: ReadonlyArray<string>;
  scenario: string;
};
export type dateFieldsPageQuery$data = {
  readonly boardScope?: {
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
    readonly id: string;
  };
  readonly jira: {
    readonly jiraCalendar: {
      readonly endDateField: {
        readonly id: string;
        readonly name: string;
        readonly type: string;
      };
      readonly startDateField: {
        readonly id: string;
        readonly name: string;
        readonly type: string;
      };
    };
    readonly jiraProjects: ReadonlyArray<{
      readonly associatedIssueLayoutFields: {
        readonly " $fragmentSpreads": FragmentRefs<"fieldSection_softwareBoardSettingsDateFields">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
};
export type dateFieldsPageQuery = {
  response: dateFieldsPageQuery$data;
  variables: dateFieldsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "configuration"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeUserPermissions"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectARIs"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scenario"
},
v4 = [
  {
    "kind": "Variable",
    "name": "configuration",
    "variableName": "configuration"
  },
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "ids.0",
            "variableName": "scenario"
          }
        ],
        "kind": "ListValue",
        "name": "ids"
      }
    ],
    "kind": "ObjectValue",
    "name": "scope"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "projectARIs"
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "includedFieldTypes": [
        "CUSTOM_DATETIME",
        "CUSTOM_DATE_PICKER",
        "STANDARD_DUE_DATE"
      ]
    }
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "scenario"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "permissions"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "dateFieldsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "concreteType": "JiraCalendar",
                "kind": "LinkedField",
                "name": "jiraCalendar",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "kind": "LinkedField",
                      "name": "startDateField",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v5/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.startDateField.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v6/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.startDateField.name"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v7/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.startDateField.type"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jiraCalendar.startDateField"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "kind": "LinkedField",
                      "name": "endDateField",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v5/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.endDateField.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v6/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.endDateField.name"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v7/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraCalendar.endDateField.type"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jiraCalendar.endDateField"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraCalendar"
            },
            {
              "args": (v8/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjects",
              "plural": true,
              "selections": [
                {
                  "args": (v9/*: any*/),
                  "concreteType": "JiraFieldConnection",
                  "kind": "LinkedField",
                  "name": "associatedIssueLayoutFields",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "fieldSection_softwareBoardSettingsDateFields"
                    }
                  ],
                  "storageKey": "associatedIssueLayoutFields(input:{\"includedFieldTypes\":[\"CUSTOM_DATETIME\",\"CUSTOM_DATE_PICKER\",\"STANDARD_DUE_DATE\"]})"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "condition": "includeUserPermissions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v10/*: any*/),
              "concreteType": "BoardScope",
              "kind": "LinkedField",
              "name": "boardScope",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v5/*: any*/),
                  "action": "THROW",
                  "path": "boardScope.id"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "CurrentUser",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v11/*: any*/),
                        "action": "THROW",
                        "path": "boardScope.currentUser.permissions"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "boardScope.currentUser"
                }
              ]
            },
            "action": "THROW",
            "path": "boardScope"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "dateFieldsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraCalendar",
            "kind": "LinkedField",
            "name": "jiraCalendar",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "startDateField",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "endDateField",
                "plural": false,
                "selections": (v12/*: any*/)
              }
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjects",
            "plural": true,
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraFieldConnection",
                "kind": "LinkedField",
                "name": "associatedIssueLayoutFields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "typeKey"
                          },
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "associatedIssueLayoutFields(input:{\"includedFieldTypes\":[\"CUSTOM_DATETIME\",\"CUSTOM_DATE_PICKER\",\"STANDARD_DUE_DATE\"]})"
              },
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includeUserPermissions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "BoardScope",
            "kind": "LinkedField",
            "name": "boardScope",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ab8af952405ea1766aaafcb4d8fdb0ca3e56e7a57a13c23a0c6dde1eda31a8c9",
    "metadata": {},
    "name": "dateFieldsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "650f1dc071e2ef9b88a14d7b112f4880";

export default node;
